import React from "react";

function TermsandService() {
  return (
    <div className="container py-4">
      <h2 className="text-center mb-4 fw-bold">
        Terms and Conditions
      </h2>

      <div
        className="p-4 border rounded shadow-sm"
        style={{ maxHeight: "90vh", overflowY: "auto", backgroundColor: "#fff" }}
      >
        <p><strong>Last Updated:</strong> November 13, 2025</p>

        <h5>1. General Information</h5>
        <p>
          Welcome to <strong>[Your Company Name]</strong> (“we,” “us,” “our”).
          By accessing or using our website <strong>[www.yourcompany.com]</strong> 
          and purchasing our products or services, you agree to comply with and 
          be bound by the following Terms and Conditions. Please read them carefully 
          before using our platform.
        </p>

        <h5>2. Products and Services</h5>
        <p>
          We specialize in the manufacturing, supply, and sale of textile products 
          including fabrics, garments, and accessories. While we make every effort 
          to display product colors and descriptions accurately, variations may 
          occur due to lighting, screen settings, or dye batches. We reserve the 
          right to modify, discontinue, or update products at any time without notice.
        </p>

        <h5>3. Orders and Payments</h5>
        <p>
          All orders are subject to acceptance and availability. Prices are listed 
          in INR (₹) unless otherwise stated. Payment must be made in full before 
          dispatch. We reserve the right to cancel any order in case of pricing 
          errors, stock unavailability, or fraudulent activity.
        </p>

        <h5>4. Shipping and Delivery</h5>
        <p>
          Delivery times are estimates only and may vary due to external factors 
          beyond our control. We are not responsible for delays caused by courier 
          services, customs, or unforeseen events.
        </p>

        <h5>5. Returns and Refunds</h5>
        <p>
          Returns are accepted only for damaged or defective products within 
          7 days of delivery. The product must be unused, unwashed, and in its 
          original packaging. Refunds will be processed after quality inspection.
        </p>

        <h5>6. Intellectual Property</h5>
        <p>
          All content on this site, including text, images, logos, and designs, 
          are the property of <strong>[Your Company Name]</strong>. Unauthorized 
          reproduction or distribution is strictly prohibited.
        </p>

        <h5>7. Limitation of Liability</h5>
        <p>
          We are not liable for any indirect, incidental, or consequential damages 
          resulting from the use or inability to use our products or services.
        </p>

        <h5>8. Privacy Policy</h5>
        <p>
          Your personal information is handled in accordance with our Privacy Policy. 
          By using our website, you consent to the collection and use of data as 
          described in our policy.
        </p>

        <h5>9. Changes to Terms</h5>
        <p>
          We reserve the right to update or modify these Terms and Conditions at any 
          time. Continued use of the website after changes constitutes your acceptance 
          of the new terms.
        </p>

        <h5>10. Contact Us</h5>
        <p>
          For any questions or concerns regarding these terms, please contact us at:  
          <br />
          <strong>Email:</strong> support@yourcompany.com  
          <br />
          <strong>Address:</strong> [Company Address, City, Country]
        </p>
      </div>
    </div>
  );
}

export default TermsandService;
